import { EnvironmentProviders, importProvidersFrom } from '@angular/core';
import { ConfigOption, FormlyModule } from '@ngx-formly/core';
import { TypeOption } from '@ngx-formly/core/lib/models';
import { DynamicFormModule } from './lib/dynamic-form.module';

export * from './lib/dynamic-form.module';
export * from './lib/dynamic-form/dynamic-form.component';
export * from './lib/types/tabs/tabs-type.component';

export const provideDynamicForms = () => [
  importProvidersFrom(DynamicFormModule),
];

export const provideDynamicFormsConfig = (config: ConfigOption) => [
  importProvidersFrom(FormlyModule.forChild(config)),
];

export const provideDynamicFormTypes = (...types: TypeOption[]) => [
  importProvidersFrom(FormlyModule.forChild({ types })),
];

export const provideDynamicFormConfig = (
  config: ConfigOption,
): EnvironmentProviders => importProvidersFrom([FormlyModule.forChild(config)]);

export * from './lib/wrappers/form-field/form-field-wrapper.component';

export * from './lib/types/divider/divider-type.component';

export * from './lib/types/phone-number/phone-number-type.component';

export * from './lib/types/password/password-type.component';

export * from './lib/wrappers/field-icon/field-icon-wrapper.component';

export * from './lib/types/custom-template/custom-template-type.component';

export * from './lib/types/select-lazy/select-lazy-type.component';

export * from './lib/types/custom-template/template-key.directive';
